import { NominateTeacher, NominateTeacherConverter } from '@/firebase/models/nominate_teacher_model'
import { db, Timestamp, } from "@/firebase/config"
import { collection, addDoc } from "firebase/firestore"

/**
 * Class to add mock nominations
 */
const addMockNominations = () => {
    
    /**
     * Adds the mock Nominations
     * @returns {Promise<void>}
     */
    const addNominations = async () => {
        for (const nom of _createMockNominations()) {
            await addDoc(collection(db, 'Nominations').withConverter(NominateTeacherConverter), nom)
        }
    }

    /**
     * Creates the list of new nominations
     * @returns {NominateTeacher[]}
     */
    function _createMockNominations() {
        return [
            new NominateTeacher(
                'Karen Martin',
                false,
                'Ayden Martin',
                'She is my mommy',
                'test@test.com',
                Timestamp.now(),
                true,
                false,
            ),
            new NominateTeacher(
                'Mrs. Test',
                true,
                '',
                'They are my favorite',
                'test@test.com',
                Timestamp.now(),
                true,
                false,
            ),
            new NominateTeacher(
                'Mr. Stark',
                true,
                '',
                'Best chemistry teacher ever!',
                'test@test.com',
                Timestamp.now(),
                true,
                false,
            ),
            new NominateTeacher(
                'Ms. testing',
                false,
                'test user',
                'allowed me to at least pass.',
                'test@test.com',
                Timestamp.now(),
                false,
                false,
            ),
        ]
    }

    return { addNominations }
}

export default addMockNominations
